import React from "react";

const BS5_GridXLarge = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_GridXLarge Component</h2>
      <p>This is the BS5_GridXLarge component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_GridXLarge;
